<template>
  <div class="contatti-intro">
    <div class="container p-bot-1 row-270-20 max">
      <div class="left text-3">
        <p class="intro">per aziende</p>
        <h1 class="heading-1 title">Mettiti in contatto con DigitXS</h1>
        <FormContact />
      </div>
      <div class="right text-3">
        <p class="intro">per partner</p>
        <h2 class="heading-1 title">Vuoi diventare partner di DigitXS?</h2>
        <p class="text-2 description">
          Per software house, system integrator, studi professionali, servizi di
          consulenza e qualunque professionista voglia integrare la sua offerta
          o arricchire la nostra.
        </p>
        <MainButton
          text="Perché diventare partner"
          url="/partner"
          :internal-link="true"
          :is-black="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContattiIntro',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
